import { createContext } from 'react';
import { noopCopilotTelemetry } from '../types/CopilotTelemetry';
export const CopilotChannelContext = /*#__PURE__*/createContext({
  channel: undefined,
  channelState: {
    appContext: {},
    isCanvasOpen: false,
    isCopilotExpanded: false,
    isNavCopilotAvailable: false,
    isWidgetOpen: false,
    isWidgetActive: false,
    layoutType: 'panel',
    breezeContext: {
      messageContexts: [],
      context: {},
      turnMetadata: {},
      conversationMetadata: {},
      agentId: undefined
    }
  },
  instanceId: undefined,
  telemetry: noopCopilotTelemetry
});